module.exports = __webpack_public_path__ + "img/appltAliRGuide-2.c83b5ae7.png";